import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Button, Image, Loader } from '@thd-olt-component-react/core-ui';

import { getCents, getDollars } from '../helpers';

const OrderSampleContent = ({
  children,
  dimensionText,
  handleClick,
  link,
  loading,
  loadingSample,
  multipleSamples,
  oosMessage,
  price,
  samplesOOS,
  showTitle
}) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const subTextClasses = classnames('order-sample__sub-text', {
    'order-sample__sub-text--link': link
  });

  const orderSampleInfoClasses = classnames('order-samples__info', {
    'order-sample__info--link': link && !isMobile,
    'order-sample__info--multiSampleLink': link && multipleSamples && isMobile
  });

  const subtext = (!multipleSamples && !link)
    ? `Order a ${dimensionText} sample`
    : 'Order a sample';

  const defaultButtonText = multipleSamples ? 'Order Sample' : 'Add Sample to Cart';
  const buttonContent = loading
    ? <Loader active small />
    : defaultButtonText;
  const priceElement = () => (
    <>
      {subtext}
      {!!price && (
        <span>&nbsp;for&nbsp;
          <span className="order-sample__sub-text--bold">
            {price < 1
              ? <span>{getCents(price)}&cent;</span>
              : <span>${getDollars(price)}</span>}
          </span>
        </span>
      )}
    </>
  );
  return (
    <div className="order-sample">
      <div className="order-sample__details">
        <Image
          alt="more-options-icon"
          className="order-sample__icon"
          src="https://assets.thdstatic.com/images/v1/more-options.svg"
          height="40"
          width="52"
        />
        <div className={orderSampleInfoClasses}>
          {showTitle && (link
            ? <span>{children}</span>
            : <span className="order-sample__sub-text--title">{children}</span>
          )}
          {!samplesOOS
            && (
              <div className={subTextClasses}>
                {
                  !link
                    ? priceElement()
                    : (
                      <Button
                        data-testid="order-sample-cta"
                        link
                        onClick={handleClick}
                        style={{ width: 'auto' }}
                      >
                        {loadingSample ? <Loader active small />
                          : (
                            <span>
                              { priceElement() }
                            </span>
                          )}
                      </Button>
                    )
                }
              </div>
            )}
          {oosMessage && samplesOOS
            && (
              <div className="order-sample__out-of-stock">
                <span>Out of Stock</span>
              </div>
            )}
        </div>
      </div>
      {!link && (
        <Button
          className="order-sample__button"
          dark
          data-testid="order-sample-cta"
          disabled={samplesOOS}
          onClick={handleClick}
          outline
        >
          {samplesOOS ? 'Out Of Stock' : buttonContent}
        </Button>
      )}
    </div>
  );
};

OrderSampleContent.displayName = 'OrderSampleContent';

OrderSampleContent.propTypes = {
  children: PropTypes.node.isRequired,
  dimensionText: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  link: PropTypes.bool,
  loading: PropTypes.bool,
  loadingSample: PropTypes.bool,
  multipleSamples: PropTypes.bool,
  oosMessage: PropTypes.bool,
  price: PropTypes.number,
  samplesOOS: PropTypes.bool,
  showTitle: PropTypes.bool.isRequired
};

OrderSampleContent.defaultProps = {
  link: false,
  loading: false,
  loadingSample: false,
  multipleSamples: false,
  oosMessage: false,
  price: NaN,
  samplesOOS: false
};

export default OrderSampleContent;
